module.exports = __webpack_public_path__ + "static/media/diageo_bg.27e03e9c.png";